import { Injectable, ChangeDetectorRef, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
import { AuthenticateService } from './authenticate.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ConnectionService, ConnectionServiceModule } from 'ng-connection-service';
import { retryWhen, delay, take, concat } from 'rxjs/operators'
import { $ } from '../../node_modules/protractor';
import cloneDeep from 'lodash/cloneDeep'
import { Observable } from '../../node_modules/rxjs';
import { BlackboxService } from './blackbox.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CdnSessionRegistrationResult } from './authenticate.service';

declare global {
  interface Window {
    RTCPeerConnection: any;
    mozRTCPeerConnection: any;
    webkitRTCPeerConnection: any;
  }
}

declare var navigator: any;
declare var Connection: any;

@Injectable({
  providedIn: 'root'
})

export class DataService {
  public dataDownloaded = false;
  public processing = [];
  public disconnectTime = 0;
  public syncProgress = "0%";
  public syncIndex = 0;
  public environment = "";//"https://localhost:5001";
  public blobUrl = "";//"https://ecomstorageproduction.blob.core.windows.net";
  public blobContainer = "";//"iwcf-cdn-test";
  public syncItems = [];
  public assessmentFrontPages: any = [];
  public bops: any = [];
  public caseStudies: any = [];
  public caseStudyInstructions: any = [];
  public caseStudyMedia: any = [];
  public languages: any = [];
  public levels: any = [];
  public media: any = [];
  public modules: any = [];
  public programmes: any = [];
  public questionMatches: any = [];
  public questionMedia: any = [];
  public questionResponseMedia: any = [];
  public questionResponses: any = [];
  public questions: any = [];
  public scheduleCandidates: any = [];
  public schedules: any = [];
  public sessionFeedbacks: any = [];
  public sessionQuestions: any = [];
  public sessionResults: any = [];
  public sessions: any = [];
  public units: any = [];
  public onlinePINs: any = [];
  public currentUser: any = {};
  public currentExamIndex = -1;
  public downloadStatus = "Loading exam data...";
  public syncStatus = "Up to date...";
  public isConnected = true;
  public timeDisconnected = 0;
  public disconnectInterval;
  public connectionFailInterval;
  public connectionFailCount;
  public expandMenu = false;
  public tinyUrl = "";
  public lastAction = "";
  public ipAddress = "";
  public publicIpAddress = "";
  public pendingApiCalls = [];
  public deviceInfo = "";
  public translationData = null;
  public enetsecureMobile = false;
  public enetsecureWeb = false;
  public allowSignalR = true;
  private ipRegex = new RegExp(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);

  constructor(
    private http: HttpClient,
    public generalSvc: GeneralService,
    private spinner: NgxSpinnerService,
    private spinner2: Ng4LoadingSpinnerService,
    private connectionService: ConnectionService,
    private deviceService: DeviceDetectorService,
    private authService: AuthenticateService,
    private zone: NgZone
  ) {
    const jsonFile = "/assets/config.json";
    this.http.get(jsonFile).toPromise().then((response: any) => {
      this.environment = response.webApiUrl;
      this.blobUrl = response.blobStorageUrl;
      this.blobContainer = response.blobStorageContainer;
      this.syncItems = response.dataSyncItems;
      this.allowSignalR = response.allowSignalR !== false;
    });

    try {
      this.deviceInfo = (deviceService.os) + "_" + (deviceService.os_version) + "_" + (deviceService.browser) + "_" + (deviceService.browser_version);
    } catch (e) {

    }

    this.determineLocalIp();
    this.determinePublicIp();

    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        clearInterval(this.disconnectInterval);
        if (this.timeDisconnected > 0)
        {
          var timeOfDisconnect = this.timeDisconnected + 1;
          if (this.currentExamIndex != -1)
          {
            this.startSyncMethods();
            var sessionId = this.currentExam().Session.SessionId;
            this.submitDisconnect(sessionId, (timeOfDisconnect * 1000));
          }
          this.timeDisconnected = 0;
          this.spinner.hide();
        }
      } 
      else {
        this.stopSyncMethods();
        this.downloadStatus = "No internet connection...";
        this.timeDisconnected = 0;
        this.spinner.show();
        this.disconnectInterval = setInterval(() => {
          this.timeDisconnected ++;
          this.downloadStatus = "No internet connection. Disconnected for "+ this.timeDisconnected.toString() +" seconds...";
        }, 1000);
      }
    });
  }

  private determineLocalIp() {
    window.RTCPeerConnection = this.getRTCPeerConnection();

    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.createDataChannel('');
    pc.createOffer().then(pc.setLocalDescription.bind(pc));

    pc.onicecandidate = (ice) => {
      this.zone.run(() => {
        if (!ice || !ice.candidate || !ice.candidate.candidate) {
          return;
        }
        try{
          this.ipAddress = this.ipRegex.exec(ice.candidate.candidate)[1];
        }
        catch{
          // this.ipAddress = ice.candidate.candidate.split(' ')[4];
        }
        
        pc.onicecandidate = () => {};
        pc.close();
      });
    };
  }

  private getRTCPeerConnection() {
    return window.RTCPeerConnection ||
      window.mozRTCPeerConnection ||
      window.webkitRTCPeerConnection;
  }

  private determinePublicIp(){
    this.http.get<{ip:string}>('https://api.ipify.org?format=json')
    .subscribe( data => {
      this.publicIpAddress = data.ip;
    });
  }

  initLogin(username, password) {
    this.spinner.show();
    this.downloadStatus = "Logging in...";
    this.http.post(this.environment + "/login", { username, password }).subscribe((data: any) => {
          if (data.status == "Success") {

            if (username.toLowerCase() === "demo") {
              this.startExamDownload(data, username, password);
              return;
            }

            if (!this.allowSignalR) {
              this.startExamDownload(data, username, password);
              return;
            }

            this.authService
              .registerSession(this.environment, data.accessToken)
              .then(sessionResult => {
                if (!sessionResult.accepted) {
                  this.downloadStatus = "You’re already logged in on another device. Please sign out from that device to continue.";
                  this.generalSvc.alreadyLoggedIn();
                  return;
                }

                this.startExamDownload(data, username, password);
              })
              .catch(error => {
                console.error('SignalR session registration failed', error);
                this.downloadStatus = "You’re already logged in on another device. Please sign out from that device to continue.";
                this.generalSvc.alreadyLoggedIn();
                return;
              });
          } else if (data.status == "Error") {
            this.downloadStatus = data.message;
            setTimeout(() => {
              this.spinner.hide();
            }, 5000);
          } else {
            this.downloadStatus = "Login details incorrect";
            setTimeout(() => {
              this.spinner.hide();
            }, 1000);
          }
        }, (error: any) => {
          this.downloadStatus = "Login details incorrect";
          setTimeout(() => {
            this.spinner.hide();
          }, 1000);
        });
  }

  private startExamDownload(data: any, username, password) {
    this.downloadStatus = "Downloading exam data...";
    var prefixUrl = this.blobUrl + "/"+ this.blobContainer +"/"+ data.scheduleId +"-" + data.scheduleCandidateId + "-"
      + (data.onlinePINs && data.onlinePINs.length > 0 ? "{pin}" : password);
    this.onlinePINs = data.onlinePINs;
    
    var suffixUrl = this.makeid(10);
    this.syncItems[0].url = prefixUrl + "/AssessmentFrontPages.json?" + suffixUrl;    
    this.syncItems[1].url = prefixUrl + "/Bops.json?" + suffixUrl;            
    this.syncItems[2].url = prefixUrl + "/CaseStudies.json?" + suffixUrl;
    this.syncItems[3].url = prefixUrl + "/CaseStudyInstructions.json?" + suffixUrl;
    this.syncItems[4].url = prefixUrl + "/CaseStudyMedia.json?" + suffixUrl;
    this.syncItems[5].url = prefixUrl + "/Languages.json?" + suffixUrl;
    this.syncItems[6].url = prefixUrl + "/Levels.json?" + suffixUrl;
    this.syncItems[7].url = prefixUrl + "/Media.json?" + suffixUrl;
    this.syncItems[8].url = prefixUrl + "/Modules.json?" + suffixUrl;
    this.syncItems[9].url = prefixUrl + "/Programmes.json?" + suffixUrl;
    this.syncItems[10].url = prefixUrl + "/QuestionMatches.json?" + suffixUrl;
    this.syncItems[11].url = prefixUrl + "/QuestionMedia.json?" + suffixUrl;
    this.syncItems[12].url = prefixUrl + "/QuestionResponseMedia.json?" + suffixUrl;
    this.syncItems[13].url = prefixUrl + "/QuestionResponses.json?" + suffixUrl;
    this.syncItems[14].url = prefixUrl + "/Questions.json?" + suffixUrl;
    this.syncItems[15].url = prefixUrl + "/ScheduleCandidates.json?" + suffixUrl;
    this.syncItems[16].url = prefixUrl + "/Schedules.json?" + suffixUrl;
    this.syncItems[17].url = prefixUrl + "/SessionFeedbacks.json?" + suffixUrl;
    this.syncItems[18].url = prefixUrl + "/SessionQuestions.json?" + suffixUrl;
    this.syncItems[19].url = prefixUrl + "/SessionResults.json?" + suffixUrl;
    this.syncItems[20].url = prefixUrl + "/Sessions.json?" + suffixUrl;
    this.syncItems[21].url = prefixUrl + "/Units.json?" + suffixUrl;
    this.processSync(username, password);
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  processSync(username, password) {
    if (this.dataDownloaded == false) {
      // We check to see if the sync Items contains the index - if not, the progress is completed;
      if (this.syncItems[this.syncIndex] != null) {
        // Get data from JSON;
        // - replace with Web Service;
        this.downloadStatus = "Downloading "+ this.syncItems[this.syncIndex].title + "...";

        if (!this.onlinePINs || this.onlinePINs.length === 0) {
          this.http.get(this.syncItems[this.syncIndex].url).subscribe((data) => {
            // Bind data;
            this[this.syncItems[this.syncIndex].object] = data;
            this.calculateProgress();

            // Iterate;
            this.syncIndex++;
            this.processSync(username, password);
          },
          (error: any) => {
            //
            this.noConnectionError();
          });
        } else {
          var syncPinsIndex = 0;
          this[this.syncItems[this.syncIndex].object] = [];

          // Iterate through each pin
          this.onlinePINs.forEach(pin => {
            this.http.get(this.syncItems[this.syncIndex].url.replace("{pin}", pin)).subscribe((data) => {
              this[this.syncItems[this.syncIndex].object] = this[this.syncItems[this.syncIndex].object].concat(data);
              syncPinsIndex++;
              if (syncPinsIndex === this.onlinePINs.length) {
                //Remove duplicate values based on unique id combination
                if (this.syncItems[this.syncIndex].ids) {
                  this[this.syncItems[this.syncIndex].object] = this[this.syncItems[this.syncIndex].object].filter((o, i, a,) => {
                    let _o = this.syncItems[this.syncIndex].ids.map(key => o[key]);
                    if(this.syncItems[this.syncIndex].title == "Session Questions"){
                      return _o;
                    }
                    else{
                      return i === a.findIndex((f) => this.syncItems[this.syncIndex].ids.map(key => f[key]).every((e, _i) => e == _o[_i]));
                    }
                  });
                }
                this.calculateProgress();
    
                // Iterate;
                this.syncIndex++;
                this.processSync(username, password);
              }
            },
            (error: any) => {
              //
              this.noConnectionError();
            });
          });
        }

      } else {
        this.dataDownloaded = true;
        this.attemptLogin(username, password);
      }
    } else {
      this.attemptLogin(username, password);
    }
  }

  attemptLogin(username, password) { 
    if (username == "demo")
      username = "000000";

    var loginFiltered = this.scheduleCandidates.filter(x => x.LoginId.toString() == "CR-" + username);
    if (loginFiltered.length > 0) {
      this.packageData(loginFiltered[0]);
      this.generalSvc.loginUser();
    } else {
      alert("You entered incorrect login details.");
    }
    this.spinner.hide();
  }

  calculateProgress() {
    this.syncProgress = (((this.syncIndex + 1) / this.syncItems.length) * 100).toFixed(0) + "%";
  }

  shuffle(array) {
      for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
      }
  }

  packageData(scheduleCandidate) {
    var schedule = this.schedules.filter(x => x.ScheduleId == scheduleCandidate.ScheduleId)[0];
    var sessionsFiltered = this.sessions.filter(x => x.ScheduleCandidateId == scheduleCandidate.ScheduleCandidateId && (scheduleCandidate.LoginId.toString() == 'CR-000000' || x.Status < 5));
    var programme = this.programmes.filter(x => x.Id == scheduleCandidate.ProgrammeId)[0];
    var level = this.levels.filter(x => x.Id == scheduleCandidate.LevelId)[0];
    var language = this.languages.filter(x => x.Id == scheduleCandidate.LanguageId)[0];
    var bop = this.bops.filter(x => x.Id == scheduleCandidate.BopId)[0];
    var exams = [];
    sessionsFiltered.forEach(session => {
      var assessmentFrontPage = this.assessmentFrontPages.filter(x => x.AssessmentId == session.AssessmentId)[0];
      var modules = this.modules.filter(x => x.Id == session.ModuleId)[0];
      var sessionQuestions = this.sessionQuestions.filter(x => x.SessionId == session.SessionId).sort(this.dynamicSort("SectionOrder"));

      var questions = [];
      sessionQuestions.forEach(sessionQuestion => {
        var question = this.questions.filter(x => x.QuestionDetailsId == sessionQuestion.QuestionDetailsId)[0];
        var questionResponses = this.questionResponses.filter(x => x.QuestionDetailsId == sessionQuestion.QuestionDetailsId).sort(this.dynamicSort("OrderNumber"));
        var questionMedia = this.questionMedia.filter(x => x.QuestionDetailsId == sessionQuestion.QuestionDetailsId);
        var questionMatches = this.questionMatches.filter(x => x.QuestionDetailsId == sessionQuestion.QuestionDetailsId);

        var allCasestudyData = [];
        var casestudy = this.caseStudies.filter(x => x.CaseStudyId == sessionQuestion.CaseStudyId);
        if(casestudy.length > 0){
          casestudy.forEach(cs => {
            var caseStudyObject: any = {};
              var instructions = this.caseStudyInstructions.filter(x => x.CaseStudyId == cs.CaseStudyId)[0]; 
              var mediaImages = [];            
              var media = this.caseStudyMedia.filter(x => x.CaseStudyId == cs.CaseStudyId);

              if (media != null && media != undefined) {
                for (var i = 0; i < media.length; i++) {  
                  var img = media[i];              
                  var mediaData = this.media.filter(x => x.Id == img.MediaId && x.UnitId == scheduleCandidate.UnitId)[0];
                  if (mediaData != null && mediaData != undefined) {        
                    if (mediaImages.filter(x => x.MediaId == img.MediaId).length == 0) {
                      mediaImages.push({
                        "MediaId": img.MediaId,
                          "Order": img.Order,
                          "Data": mediaData.Data,
                          "ContentType": "image/jpeg",
                          "Name": mediaData.Name,
                          "Activated": false,
                          "Description" : mediaData.Description
                      });
                    }
                  }                
                }                           
              };    

              mediaImages = mediaImages.filter((v, i, a) => a.indexOf(v) === i); 

              caseStudyObject = {
                "CaseStudyId": cs.CaseStudyId,
                "Name": cs.Name,
                "Instructions": instructions != null ? instructions.Instructions.replace(/&nbsp;/g, ' ') : "", //.replace(/<[^>]*>?/gm, '')
                "Media": mediaImages            
              }

              if (allCasestudyData.filter(x => x.CaseStudyId == caseStudyObject.CaseStudyId).length == 0) {
                allCasestudyData.push(caseStudyObject);        
              }
          })
        }
        
        questionMatches.forEach(questionMatch => {
          try {
            var parsedAnswerText = parseInt(questionMatch.AnswerText);
            if (!isNaN(parsedAnswerText)) {
              questionMatch.AnswerText = parsedAnswerText;
            }
          } catch {

          }
        });
        
        questionMatches.sort(this.dynamicSort("AnswerText"));
        var questionResults = this.sessionResults.filter(x => x.SessionId == sessionQuestion.SessionId && x.QuestionDetailsId == sessionQuestion.QuestionDetailsId)[0];

        var _questionResponses = [];
        var responseIndex = 0;
        questionResponses.forEach(questionResponse => {
          if (question.Type != 6 && question.Type != 4 && question.Type != 8)
          {
            try {
              if (questionResults.Selection.toString().indexOf(questionResponse.Id.toString()) > -1)
                questionResponse.Answer = true;
              else
                questionResponse.Answer = null;
            } catch {
              
            }
          }
          else if(question.Type == 4 || question.Type == 8){
            var answer = questionResults.Selection.toString();
            if(answer != "" && answer!= null && answer != undefined){
              questionResponse.Answer = answer
            }
          } else {
            try {
              var selectionArray = questionResults.Selection.toString().split(',')[responseIndex];
              questionResponse.Answer = selectionArray;
            } catch {

            }
            responseIndex++;
          }

          var questionResponseMedia = this.questionResponseMedia.filter(x => x.QuestionResponseId == questionResponse.Id);

          _questionResponses.push({
            "Response": questionResponse,
            "Media": questionResponseMedia,
            "Feedback": false
          })
        });
    
        var questionResponsesAnswered = _questionResponses.filter(x => x.Response.Answer == true).length;
        var disabled = null; 

        if (question.Type != 6 && question.Type != 4 && question.Type != 8)
        {
          if (question.NumberOfAnswers <= questionResponsesAnswered)
            disabled = true;
        }
        else if(question.Type == 4 || question.Type == 8){
          var answer = _questionResponses.filter(x => x.Response.Answer != null && x.Response.Answer != "").length;
          if(answer > 0){
            disabled = true;
          }
        }
         else {
          if (_questionResponses.filter(x => x.Response.Answer == null).length == 0)
            disabled = true;
        }
        
        var _media = [];
        questionMedia.forEach(qMedia => {
          var media = this.media.filter(x => x.Id == qMedia.MediaId)[0];

          _media.push({
            "QuestionMedia": qMedia,
            "Media": media
          });
        });

        var timeTaken = 0;

        try
        {
          timeTaken = questionResults.Timetaken;
        }
        catch
        {
          // 
        }

        // Remove duplicate media;
        _media = _media.filter(function(elem, index, self) {
          return index === self.indexOf(elem);
        });

        allCasestudyData = allCasestudyData.filter((v, i, a) => a.indexOf(v) === i); 
        questions.push({
          "TimeSpent": timeTaken,
          "SessionQuestion": sessionQuestion,
          "Question": question,
          "Media": _media,
          "Matches": questionMatches,
          "QuestionResponses": _questionResponses,
          "Result": questionResults,
          "Feedback": false,
          "Disabled": disabled,
          "CaseStudies" : allCasestudyData
        });
      });

      
      exams.push({
        "FrontPage": assessmentFrontPage,
        "Session": session,
        "Completed": !(scheduleCandidate.LoginId.toString() == 'CR-000000' || session.Status < 5),
        "Module": modules,
        "Bop": bop,
        "Questions": questions,
        "CurrentQuestion": 0,
        "Progress": (scheduleCandidate.LoginId.toString() == 'CR-000000') ? 0 : this.round((questions.filter(q => q.Disabled).length / questions.length) * 100),
        "Status": session.Status,
        "StatusText": (scheduleCandidate.LoginId.toString() == 'CR-000000' || session.Status < 5) ? "Not Started" : "Completed",
      });

      exams.forEach(exam => {
        exam.Questions.forEach(question => {
          question.Question.QuestionTextHiddenImages = this.processQuestionContent(question.Question.QuestionText, question, false);
          question.Question.QuestionText = this.processQuestionContent(question.Question.QuestionText, question, true);
        });
      });

      exams = JSON.parse(JSON.stringify(exams));
    });

    if (scheduleCandidate.IsDualLanguage && scheduleCandidate.SecondLanguageId && scheduleCandidate.SecondLanguageId > 0) {
      this.questions.filter(q => q.LanguageId == scheduleCandidate.SecondLanguageId).forEach(q => {
        q.QuestionText = this.processTranslationContent(q.QuestionText);
      });
    }

    //Hide empty exams
    exams = exams.filter(exam => exam.Questions.length > 0);

    this.currentUser = {
      "Language": language,
      "ScheduleCandidate": scheduleCandidate,
      "Schedule": schedule,
      "Programme": programme,
      "Level": level,
      "Exams": exams
    };
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
  }

  previousQuestion() {
    this.pulseTimeLog('Previous');
    setTimeout(() => {
      this.updateViewerHeights();
    }, 2500);
    this.currentExam().CurrentQuestion += -1;
    this.checkForTranslation();
  }

  nextQuestion() {
    this.pulseTimeLog('Next');
    setTimeout(() => {
      this.updateViewerHeights();
    }, 2500);
    this.currentExam().CurrentQuestion += 1;
    this.checkForTranslation();
  }

  checkForTranslation() {
    var scheduleCandidate = this.scheduleCandidates.find(sc => sc.ScheduleCandidateId == this.currentExam().Session.ScheduleCandidateId);
    if (scheduleCandidate && scheduleCandidate.IsDualLanguage && scheduleCandidate.SecondLanguageId) {
      var question = this.currentQuestion().Question;
      var td = {};
      var _question = this.questions.find(q => question.QuestionId == q.QuestionId && q.LanguageId == scheduleCandidate.SecondLanguageId);
      if (_question) {
        if(_question.QuestionText.indexOf("<img") > 0){
          var newQuestionText = _question.QuestionText.replace(/<img[^>]*>/g,"").trim();
          newQuestionText = newQuestionText.replace(/<p(\s+[a-z0-9\-_\'\"=]+)*> <\/p>/ig, '').replace(/\r?\n?/g, '').replaceAll("style=\"text-align: center;\"", "").replaceAll("<p >", "<p>").replaceAll("<p> </p>", "").replaceAll("<p></p>", "").trim();
          
          td['q'] = newQuestionText;
        }
        else{
          td['q'] = _question.QuestionText;
        }
        
        td['s'] = this.languages.find(l => scheduleCandidate.SecondLanguageId == l.Id);
        var responses = this.questionResponses.filter(qr => _question.QuestionDetailsId == qr.QuestionDetailsId);
        if (responses) {
          td['r'] = responses.sort(this.dynamicSort("OrderNumber"));
        }
        this.translationData = td;
        return;
      }
    }
    this.translationData = null;
  }

  checkForBop(){
    var bop = this.currentUser.Exams[this.currentExamIndex].Bop;
    if(bop != null){
      return "(" + bop.Name + ")";
    }
    else{
      return " ";
    }
  }

  caseStudyExists(){
    if(this.currentQuestion().CaseStudies.length > 0){
      return true;
    }
    else{
      return false;
    }
  }

  flagResponse(reponseId){
    var questionResponse = this.currentQuestion().QuestionResponses.filter(x => x.Response.Id == reponseId);
    if(questionResponse[0].Feedback){
      questionResponse[0].Feedback = false;
    }
    else{
      questionResponse[0].Feedback = true;
    }
  }

  isResponseFlagged(reponseId){
    var questionResponse = this.currentQuestion().QuestionResponses.filter(x => x.Response.Id == reponseId);
    return questionResponse[0].Feedback;
  }

  getFeedbackResponses(){
    return this.currentExam().Questions;   
  }

  flagQuestion(){
    var flagged = this.currentQuestion().Feedback;
    if(flagged){
      this.currentQuestion().Feedback = false;

      // unflag responses;
      if (this.currentQuestion().Question.Type != 8 && this.currentQuestion().Question.Type != 4) {
        this.currentQuestion().QuestionResponses.forEach((response: any) => {
          response.Feedback = false;
        });
      }
    }
    else{
      this.currentQuestion().Feedback = true;

      // flag responses;
      if (this.currentQuestion().Question.Type != 8 && this.currentQuestion().Question.Type != 4) {
        this.currentQuestion().QuestionResponses.forEach((response: any) => {
          response.Feedback = true;
        });
      }
    }
    this.pulseTimeLog('Flagged');
  }

  isQuestionFlagged(){
    return this.currentQuestion().Feedback; 
  }

  getFeedbackQustions(){
    return this.currentExam().Questions.filter(x => x.Feedback == true);
  }

  getClickedMedia(){
    return this.currentQuestion().Media.filter(x => x.Activated == true);
  }

  getClickedMediaId(mediaId){
    setTimeout(() => {
      this.updateViewerHeightsWithId(mediaId);
    }, 2500);
    return this.currentQuestion().Media.filter(x => x.Activated == true && x.Media.Id == mediaId);
  }

  addToClickedMedia(mediaId){
    var clickedMedia = this.getClickedMediaId(mediaId);
    if (clickedMedia.length == 0)
    {
      var media = this.media.filter(x => x.Id == mediaId)[0];
      var newMedia = {
        Media: media, 
        Activated: true
      };
      this.currentQuestion().Media.push(newMedia);
      this.getClickedMedia();
    }

    setTimeout(() => {
      this.updateViewerHeightsWithId(mediaId);
    }, 2500);
  }

  setQuestion(i) {
    this.pulseTimeLog('Navbar');
    this.currentExam().CurrentQuestion = i;
    this.checkForTranslation();
  }

  currentQuestion() {
    return this.currentExam().Questions[this.currentExam().CurrentQuestion];
  }

  currentExam() {
    return this.currentUser.Exams[this.currentExamIndex];
  }

  updateResponse(response, val) {
    response.Response.Answer = val;

    var question = this.currentQuestion();

    var questionResponses = question.QuestionResponses.filter(x => x.Response.Answer == true);

    if (questionResponses.length >= question.Question.NumberOfAnswers) {
      question.Disabled = true;
    } else {
      question.Disabled = null;
    }

    var selectedIds = [];
    questionResponses.forEach((response: any) => {
      selectedIds.push(response.Response.Id);
    });

    this.pulseTimeLog('Answer');

    var answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": selectedIds.join(),
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };
    this.submitResult(answer.sessionId, answer.questionId, answer.answer, answer.sectionId, answer.questionDetailsId, answer.timeSpent);

    this.calculateExamProgress();
  }

  updateResponseMatching() {
    var question = this.currentQuestion();
    if (question.QuestionResponses.filter(x => x.Response.Answer == null).length == 0) {
      question.Disabled = true;
    } else {
      question.Disabled = null;
    }

    var questionResponses = question.QuestionResponses.filter(x => x.Response.Answer != null);

    var selectedIds = [];

    questionResponses.forEach((response: any) => {
      var questionMatch = question.Matches.filter(x => x.Id == response.Response.Answer)[0];
      //selectedIds.push(response.Response.Id + ":" + questionMatch.AnswerText)
      //selectedIds.push(response.Response.Answer);
      selectedIds.push(response.Response.Id + ":" + questionMatch.AnswerText);
    });

    this.pulseTimeLog('Answer');

    var answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": selectedIds.join(),
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };

    this.submitResult(answer.sessionId, answer.questionId, answer.answer, answer.sectionId, answer.questionDetailsId, answer.timeSpent);

    this.calculateExamProgress();
  }

  parseValueNumeric(question, val){  
    var regex = /[^0-9.-]*/g;
    if(val.charAt(0) == "."){
      val = val.replace(".", "0.")
    }
    if (val.indexOf(",") > -1){
      question.Comma = true;
      val = val.replace(",", "");
    } else {
      question.Comma = null;
    }
    return val.replace(regex, ''); 
  }

  updateResponseCalculationVal(answer)
  {
    var question = this.currentQuestion();
    answer = this.parseValueNumeric(question, answer);

    // Update response answer;
    question.QuestionResponses[0].Response.Answer = answer;

    if(answer != null && answer != undefined){
      question.Disabled = true;
    }
    else{
      question.Disabled = false;
    }

    this.pulseTimeLog('Answer');

    var _answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": answer,
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };
    this.submitResult(_answer.sessionId, _answer.questionId, _answer.answer, _answer.sectionId, _answer.questionDetailsId, _answer.timeSpent);

    this.calculateExamProgress();
  }

  updateResponseCalculation(obj, answer){  
    var question = this.currentQuestion();
    answer = this.parseValueNumeric(question, answer);
    obj.value = answer;

    // Update response answer;
    question.QuestionResponses[0].Response.Answer = answer;

    if(answer != null && answer != undefined){
      question.Disabled = true;
    }
    else{
      question.Disabled = false;
    }

    this.pulseTimeLog('Answer');

    var _answer = {
      "questionId": question.Question.QuestionId,
      "sessionId": this.currentExam().Session.SessionId,
      "answer": answer,
      "sectionId": question.SessionQuestion.SectionId,
      "questionDetailsId": question.SessionQuestion.QuestionDetailsId,
      "timeSpent": question.TimeSpent
    };

    this.submitResult(_answer.sessionId, _answer.questionId, _answer.answer, _answer.sectionId, _answer.questionDetailsId, _answer.timeSpent);
    this.calculateExamProgress();
  }

  calculateExamProgress() {
    var questions = this.currentExam().Questions;
    var completed = questions.filter(x => x.Disabled == true);
    this.currentExam().Progress = this.round((completed.length / questions.length) * 100);
  }

  EndExam()
  {
    this.spinner.show();
    this.downloadStatus = this.translateText() + "...";
    var sessionId = this.currentExam().Session.SessionId;
    this.pulseTimeLog('End');
    this.submitCompletion(sessionId);
  }

  translateText(){
    var language = this.currentUser.Language.Name;
    if(language == "Arabic"){      
        return "اكتمل التقييم-تقديم النتائج";
    }
    else if(language == "Azerbaijani"){      
      return "Qiymətləndirmə sona çatdı – Nəticələrin təqdim edilməsi";
    }
    else if(language == "Chinese"){      
        return "测评完成，正在提交结果";
    }
    else if(language == "Croatian"){      
        return "Procjena je završena – slanje rezultata";   
    }
    else if(language == "Czech"){      
        return "Hodnocení dokončeno – odesílají se výsledky";
    }
    else if(language == "Dutch"){     
        return "Toets beëindigd - Resultaten verzenden";
    }
    else if(language == "English"){     
        return "Assessment Finished – Submitting Results";
    }
    else if(language == "French"){    
        return "Évaluation terminée – soumission des résultats";
    }
    else if(language == "German"){      
        return "Prüfung abgeschlossen – Ergebnisse einreichen";
    }
    else if(language == "Hindi"){      
        return "Question(s) Flagged for Review";
    }
    else if(language == "Hungarian"){
        return "Értékelő teszt kész – Eredmények beküldése";
    }
    else if(language == "Indonesian"){
        return "Question(s) Flagged for Review";
    }
    else if(language == "Italian"){    
        return "Valutazione terminata – Invio risultati in corso";
    }
    else if(language == "Malay"){    
        return "Question(s) Flagged for Review";
    }
    else if(language == "Norwegian"){     
        return "Evaluering avsluttet – overfører resultater";
    }
    else if(language == "Polish"){
              return "Test zakończony – przesyłanie wyników";
    }
    else if(language == "Portuguese"){      
        return "Question(s) Flagged for Review";
    }
    else if(language == "Portuguese Brazilian"){      
        return "Avaliação concluída – enviando resultados";
    }
    else if(language == "Romanian"){
        return "Evaluare încheiată – Se transmit rezultatele";
    }
    else if(language == "Russian"){      
        return "Тест завершен — выполняется отправка результатов";
    }
    else if(language == "Spanish"){     
        return "Evaluación finalizada – Enviando resultados";
    }
    else if(language == "Spanish South American"){      
        return "Evaluación finalizada – Enviando resultados";
    }
    else if(language == "Thai"){     
        return "การประเมินเสร็จสิ้น - กำลังส่งผลลัพธ์";
    }
    else if(language == "Turkish"){      
        return "Değerlendirme Bitti – Sonuçlar Gönderiliyor";
    }
    else{
      return "Assessment Finished – Submitting Results";
    }
  }

  processQuestionContentReview(question)
  {
    var content = question.Question.QuestionText;
    var mid = 0;
    var regex = /<img.*?src="(.*?)"/;
      try
      {
        var src = regex.exec(content)[1];
        var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");

        mid = Number(mediaId);
      } catch (e) {
        
        try {
          regex = /<img.*?src='(.*?)'/;
          var src = regex.exec(content)[1];
          var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
          mid = Number(mediaId);
        } catch (es) {

        }
      }
      return mid;
  }

  processQuestionContent(content, question, show) {
    if (show){
      var regex = /<img.*?src="(.*?)"/;
      try
      {
        var src = regex.exec(content)[1];
        var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
        var media = question.Media.filter(x => x.Media.Id == mediaId)[0];
        question.Question.QuestionTextMedia = media.Media.Id;
        content = content.replace("src=\"" + src, "class=\"image_in_question\" onclick=\"document.getElementById('img_"+ mediaId +"').click(); this.style.display = 'none';\" src=\"data:image/png;base64," + media.Media.Data);
      } catch (e) {
        try {
          regex = /<img.*?src='(.*?)'/;
          var src = regex.exec(content)[1];
          var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
          var media = question.Media.filter(x => x.Media.Id == mediaId)[0];
          question.Question.QuestionTextMedia = media.Media.Id;
          content = content.replace("src='" + src, "class=\"image_in_question\" onclick=\"document.getElementById('img_"+ mediaId +"').click(); this.style.display = 'none';\" src='data:image/png;base64," + media.Media.Data);
        } catch (e) {

        }
      }
    } else {
      var content = content.replace(/<img[^>]*>/g,"");
    }

    content = this.addDirAttributeToTables(content);

    return content;
  }

  addDirAttributeToTables(htmlString: string): string {
    try {
    // Parse HTML string into DOM structure
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // Find all table elements
      const tables = doc.querySelectorAll('table');

      // Loop through each table
      tables.forEach((table) => {
          // Check if dir attribute is set
          if (!table.hasAttribute('dir')) {
              // If dir attribute is not set, add it with value "ltr"
              table.setAttribute('dir', 'ltr');
          }
      });

      // Serialize modified DOM back into HTML string
      const modifiedHtmlString = new XMLSerializer().serializeToString(doc);
      
      return modifiedHtmlString;
    } catch(e)
    {
      return htmlString;
    }
  }

  processTranslationContent(content) {
    var regex = /<img.*?src="(.*?)"/;
    var search = regex.exec(content);
    if (search !== null) {
      var src = search[1];
      var mediaId = src.replace("/eCom/Handlers/MediaHandler.ashx?id=", "");
      var media = this.media.find(x => x.Id == mediaId);
      content = content.replace("src=\"" + src, "class=\"image_in_question\" onclick=\"document.getElementById('img_"+ mediaId +"').click(); this.style.display = 'none';\" src=\"data:image/png;base64," + media.Data);
    }
    return content;
  }

  round(value) {
    var multiplier = Math.pow(10, 0);
    return Math.round(value * multiplier) / multiplier;
  }

  roundToDecimal(value) {
    var multiplier = Math.pow(10, 1);
    return Math.round(value * multiplier) / multiplier;
  }

  runQuery(query) {

  }

  getQuery(query) {

  }

  getAll(query) {
    return "";
  }

  updateViewerHeights()
  {
    var imageViewers: any = document.querySelectorAll(".image-gallery-2");
    imageViewers.forEach(imageViewer => {
      this.setViewerHeight(imageViewer);
    });

    setTimeout(() => {
      var buttons: any = document.querySelectorAll(".material-icons.prev");
      buttons.forEach(button => {
        button.click();
      });
    }, 500);
  }

  updateViewerHeightsWithId(mediaId)
  {
    var imageViewers: any = document.querySelectorAll("#media_container_" + mediaId + ".image-gallery-2");
    imageViewers.forEach(imageViewer => {
      this.setViewerHeight(imageViewer);
    });

    setTimeout(() => {
      var buttons: any = document.querySelectorAll("#media_container_" + mediaId + " .material-icons.prev");
      buttons.forEach(button => {
        button.click();
      });
    }, 500);
  }

  setViewerHeight(imageViewer: any)
  {
    var i = imageViewer.querySelectorAll("img")[0];
    var scaleH = i.height / i.width;
    var currentW = imageViewer.clientWidth;
    imageViewer.style.height = (currentW * scaleH).toString() + "px";
  }

  // Submit data to the API;
  public resultInterval = null;
  public logInterval = null;
  public sessionRefreshInterval = null;
  private sessionRefreshInFlight = false;

  startSyncMethods()
  {
    this.stopSyncMethods();

    this.logInterval = setInterval(() => {
      this.determineLocalIp();
      this.determinePublicIp();
      this.pulseTimeLog("Pulse");
    }, 90000);

    this.startSessionRefresh();
  }

  stopSyncMethods()
  {
    clearInterval(this.logInterval);
    this.logInterval = null;
  }

  private startSessionRefresh()
  {
    if (!this.allowSignalR) {
      return;
    }

    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") {
      return;
    }

    if (this.sessionRefreshInterval) {
      return;
    }

    this.refreshSignalRSession();
    this.sessionRefreshInterval = setInterval(() => {
      this.refreshSignalRSession();
    }, 60000);
  }

  public stopSessionRefresh()
  {
    clearInterval(this.sessionRefreshInterval);
    this.sessionRefreshInterval = null;
    this.sessionRefreshInFlight = false;
  }

  private refreshSignalRSession()
  {
    if (!this.allowSignalR) {
      return;
    }

    if (this.sessionRefreshInFlight) {
      return;
    }

    this.sessionRefreshInFlight = true;
    this.authService.refreshSession(this.environment)
      .then(refreshed => {
        this.sessionRefreshInFlight = false;

        if (!refreshed) {
          this.handleSignalRSessionRefreshFailure();
        }
      })
      .catch(error => {
        this.sessionRefreshInFlight = false;
        console.error('SignalR session refresh failed', error);
      });
  }

  private handleSignalRSessionRefreshFailure()
  {
    var rejection = this.authService.getLastSessionRejection();
    var rejectionReason = rejection && rejection.reason ? rejection.reason : "";
    var isDuplicateLogin = rejectionReason.toLowerCase().indexOf("already logged in") > -1;

    this.stopSyncMethods();
    this.stopSessionRefresh();

    if (isDuplicateLogin) {
      this.downloadStatus = "You’re already logged in on another device. Please sign out from that device to continue.";
      this.generalSvc.alreadyLoggedIn();
      return;
    }

    this.downloadStatus = rejectionReason || "Your secure exam session could not be verified. Please log in again to continue.";
    this.generalSvc.logoutUser("");
  }

  getResults()
  {
    this.spinner2.hide();
  }

  pulseTimeLog(action) {
    this.lastAction = action;

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var connectionInfo = "";

    try {
      if (connection.type != null && connection.type != undefined)
        connectionInfo += " - T: " + connection.type;
    } catch (e) {

    }
    try{
      var networkState = navigator.connection.type;

      var states = {};
      states[Connection.UNKNOWN] = 'Unknown connection';
      states[Connection.ETHERNET] = 'Ethernet connection';
      states[Connection.WIFI] = 'WiFi connection';
      states[Connection.CELL_2G] = 'Cell 2G connection';
      states[Connection.CELL_3G] = 'Cell 3G connection';
      states[Connection.CELL_4G] = 'Cell 4G connection';
      states[Connection.NONE] = 'No network connection';
      
      connectionInfo += " - CT: " + states[networkState];
    }catch(e){

    }
    try {
      if (connection.downlink != null && connection.downlink != undefined)
        connectionInfo += " - D: " + connection.downlink;
    } catch (e) {

    }

    try {
      if (connection.rtt != null && connection.rtt != undefined)
        connectionInfo += " - R: " + connection.rtt;
    } catch (e) {

    }

    try {
      if (connection.downlinkMax != null && connection.downlinkMax != undefined)
        connectionInfo += " - DM: " + connection.downlinkMax;
    } catch (e) {

    }

    try {
      if (connection.effectiveType != null && connection.effectiveType != undefined)
        connectionInfo += " - ET: " + connection.effectiveType;
    } catch (e) {

    }

    try {
      if (connection.saveData != null && connection.saveData != undefined)
        connectionInfo += " - SD: " + connection.saveData;
    } catch (e) {

    }

    var version = document.getElementById("version").innerHTML;
    var sessionId = this.currentExam().Session.SessionId;
    var assessmentId = this.currentExam().Session.AssessmentId;
    var scheduleId = this.currentExam().Session.ScheduleId;
    var candidateId = this.currentUser.ScheduleCandidate.CandidateId;
    var scheduleCandidateId = this.currentExam().Session.ScheduleCandidateId;
    var ipAddress = this.lastAction + "_" + (this.ipAddress.length == 0 ? this.publicIpAddress : this.ipAddress);
    var cdnServerLocation = (sessionId + "_" + scheduleCandidateId + "_" + version + " - " + this.deviceInfo + connectionInfo);
    if(this.enetsecureMobile){
      cdnServerLocation = cdnServerLocation + "_eNetSecureMobile";
    }
    else if(this.enetsecureWeb){
      cdnServerLocation = cdnServerLocation + "_eNetSecureWeb";
    }
    var session = this.currentExam().Session;
    var allocatedTime = parseInt(session.AllotedTime) + parseInt(session.ExtraTime);
    var secondsSpent = session.TimeTakenInSeconds;

    this.submitTimeLog(sessionId, assessmentId, scheduleId, candidateId, ipAddress, cdnServerLocation, allocatedTime, secondsSpent);

    this.lastAction = "";
  }
  recordDisconnection()
  {
    var sessionId = this.currentExam().Session.SessionId;
    this.submitDisconnect(sessionId, this.disconnectTime);
  }
  submitResult(sessionId, questionId, answer, sectionId, questionDetailsId, timeSpent)
  {
    this.spinner2.show();
    this.downloadStatus = "Submitting answer...";

    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") 
      this.getResults();
    
    if (answer == "")
      answer = "-NOANSWER-";

    var url = this.environment + "/result/" + sessionId + "/" + questionId + "/" + answer + "/" + sectionId + "/" + questionDetailsId + "/" + timeSpent;
    
    this.http.get(url).subscribe((data: any) => {
      this.getResults();
    },
    (error: any) => {
      //
      this.noConnectionError();
    });
  }

  noConnectionError()
  {
    this.connectionFailCount = 1;
    this.spinner.show();

    this.connectionFailInterval = setInterval(() => {
      this.downloadStatus = "Connection to IWCF lost... Logging out in " + this.connectionFailCount.toString();
      this.connectionFailCount++;

      if (this.connectionFailCount > 5)
      {
        this.spinner.hide();
        window.location.reload();
      }
    }, 1000);
  }

  submitTimeLog(sessionId, assessmentId, scheduleId, userId, ipAddress, cdnServerLocation, allocatedTime, secondsSpent)
  {
    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") 
       return;

    var url = this.environment + "/pulse/" + sessionId + "/" + assessmentId + "/" + scheduleId + "/" + userId + "/" + ipAddress + "/" + cdnServerLocation + "/" + allocatedTime + "/" + secondsSpent;
    this.http.get(url).subscribe((data: any) => {
      // 
    },
    (error: any) => {
      //
      this.noConnectionError();
    });
  }
  submitDisconnect(sessionId, milliseconds)
  {
    this.determineLocalIp();
    this.determinePublicIp();

    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") {
      this.currentExam().Session.TimeStarted = new Date(this.currentExam().Session.TimeStarted + milliseconds);
      this.currentExam().Session.ExpectedEndTime = new Date(this.currentExam().Session.ExpectedEndTime + milliseconds);
    }
    
    var url = this.environment + "/disconnect/" + sessionId + "/" + milliseconds;

    // Add disconnect time to exam;
    this.http.get(url).subscribe((data: any) => {
      this.currentExam().Session.TimeStarted = new Date(this.currentExam().Session.TimeStarted + milliseconds);
      this.currentExam().Session.ExpectedEndTime = new Date(this.currentExam().Session.ExpectedEndTime + milliseconds);
    },
    (error: any) => {
      //
      this.noConnectionError();
    });
  }

  public interval: any;

  submitCompletion(sessionId)
  {

    // Stop exam timer;
    clearInterval(this.interval);

    // Stop other timers from running;
    this.stopSyncMethods();

    this.pulseTimeLog('Complete');

    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") {
      this.currentExam().Completed = true;
      this.spinner.hide();
      this.generalSvc.goToFeedback();
      return;
    }
    
    // Submit completion;
    var url = this.environment + "/complete/" + sessionId;
    this.http.get(url).subscribe((data: any) => {      
      // Completed;
      this.currentExam().Completed = true;
      this.spinner.hide();
      this.generalSvc.goToFeedback();
    },
    (error: any) => {
      //
      this.noConnectionError();
    });
  }

  submitFeedback(sessionId, feedback)
  {
    //var feedbackString = feedback.toString().split('(').join('_').split(')').join('~').split('?').join('¬').split('/').join('|');
    //var url = this.environment + "/feedback/" + sessionId + "/" + encodeURIComponent(feedbackString);
    this.postFeedback(sessionId, feedback);
  }

  postFeedback(sessionId, feedback) {
    if (this.currentUser.ScheduleCandidate.LoginId == "CR-000000") 
      this.generalSvc.goToEnetassess();
    
    var feedbackString = feedback.toString().split('(').join('_').split(')').join('~').split('?').join('¬').split('/').join('|');
    feedbackString = feedbackString.replace("\"", "&quot;");

    var json = {
      "Feedback" : feedbackString
    }
    var url = this.environment + "/PostFeedback/" + sessionId;
    this.http.post(url, json).subscribe((data:any) => {
      this.generalSvc.goToEnetassess();
    }, (error:any) => {
      this.noConnectionError();
    });
  }

  submitFeedbackShorten(url) {
    var tinyurl = 'http://tinyurl.com/api-create.php?url=' + url;
    return this.http.get(tinyurl).subscribe((data: any) => {
      if(data != null){
        this.http.get(data.toString()).subscribe((d: any) => {
          this.generalSvc.goToEnetassess();
        },(error: any) => {

        });
      }
    },(error: any) => {
      alert(error);
    });
  }
}
